export default __webpack_public_path__ + "static/media/manu.39ac720e.png";